<template>
  <div class="instant-answer-container">
    <EInstantAnswer
      class="example-instant-answer"
      :sources="sources"
      :feedback-link="feedbackLink"
    >
      <h3 class="title">
        InstantAnswer
      </h3>
      <p class="paragraph">
        This is the instant answer's content. Culpa eiusmod veniam
        velit culpa officia exercitation. Proident pariatur
        nostrud voluptate magna voluptate minim non.
      </p>
    </EInstantAnswer>
    <EInstantAnswer
      class="example-instant-answer"
      :sources="manySources"
      :feedback-link="feedbackLink"
    >
      <h3 class="title">
        InstantAnswer
      </h3>
      <p class="paragraph">
        InstantAnswer with a lot of sources
      </p>
    </EInstantAnswer>
    <EInstantAnswer class="example-instant-answer" :sources="[]" :feedback-link="feedbackLink">
      <h3 class="title">
        InstantAnswer
      </h3>
      <p class="paragraph">
        InstantAnswer with no sources
      </p>
    </EInstantAnswer>
  </div>
</template>

<script>
import EInstantAnswer from './index';

export default {
  name: 'Base',
  components: { EInstantAnswer },
  computed: {
    feedbackLink: () => ({
      ticketSubject: 'Search - My app',
      title: 'What is your feedback?',
      successTitle: 'Success',
      successMessage: 'Thank you',
      textareaPlaceholder: 'Tell us more (optional)',
      subjectsPlaceholder: 'Please choose an option',
      buttonText: 'Send',
      options: ['Option'],
      subjects: ['Subject'],
      submitText: 'Submit',
      url: 'https://httpstat.us/200',
      errorMessage: 'Oops, there was an error sending feedback',
    }),
    sources: () => [
      {
        title: 'Ecosia',
        url: 'https://www.ecosia.org',
      },
      {
        title: 'Best Data Source',
        url: 'https://data-sources.ecosia.org',
      },
    ],
    manySources: () => [
      {
        title: 'Ecosia',
        url: 'https://www.ecosia.org',
      },
      {
        title: 'Ecosia',
        url: 'https://www.ecosia.org',
      },
      {
        title: 'Ecosia',
        url: 'https://www.ecosia.org',
      },
      {
        title: 'Ecosia',
        url: 'https://www.ecosia.org',
      },
      {
        title: 'Ecosia',
        url: 'https://www.ecosia.org',
      },
      {
        title: 'Ecosia',
        url: 'https://www.ecosia.org',
      },
      {
        title: 'Ecosia',
        url: 'https://www.ecosia.org',
      },
      {
        title: 'Best Data Source',
        url: 'https://data-sources.ecosia.org',
      },
      {
        title: 'Data source with very long nameeeeeeeeeeee',
        url: 'https://data-sources-with-very-long-name.ecosia.org',
      },
    ],
  },
};
</script>

<style lang="scss">
.instant-answer-container {
  align-items: flex-start;
  display: flex;
}

.example-instant-answer {
  width: 400px;
  margin: $space-s;
}

.title,
.paragraph {
  margin: 0;
}
</style>

<include-source />
